import { ACTIONS, initialState, reducer } from "./collectorADGroupsReducer";
import { useReducer, useContext } from "react";
import AuthContext from "../../components/context/AuthContext";
import axios from "axios";

const useEditUser = () => {
  const authCtx = useContext(AuthContext);
  const [state, dispatch] = useReducer(reducer, initialState);

  const adGroupSelectHandler = (selectedOption) => {
    dispatch({ type: ACTIONS.SELECT_AD_GROUP, value: selectedOption });
    dispatch({ type: ACTIONS.VALIDATE_FORM });
  };

  const memberSelectHandler = (selectedOption) => {
    dispatch({ type: ACTIONS.SELECT_GROUP_MEMBER, value: selectedOption });
    dispatch({ type: ACTIONS.VALIDATE_FORM });
  };

  const emailChangeHandler = (event) => {
    dispatch({ type: ACTIONS.SET_EMAIL, value: event.target.value });
    dispatch({ type: ACTIONS.VALIDATE_FORM });
  };

  const convertMemberHandler = (data) => {
    let members = data?.map((option) => {
      return { value: option, label: option.name };
    });
    members.unshift({ value: state.newMember, label: state.newMember });
    return members;
  };

  const convertADGroupHandler = (data) => {
    return data?.map((option) => {
      return { value: option, label: option };
    });
  };

  // Method to clear the state's status.
  const clearStatus = () => {
    dispatch({
      type: ACTIONS.SET_STATUS,
      value: "",
    });
  };

  const submissionResponseHandler = (response) => {
    response && response.data
      ? dispatch({
          type: ACTIONS.SET_STATUS,
          value: response?.data ? response.data : "Submission successful!",
        })
      : dispatch({
          type: ACTIONS.SET_STATUS,
          value: "Submission error: Invalid response returned",
        });
  };

  const submissionResponseErrorHandler = (error) => {
    dispatch({
      type: ACTIONS.SET_STATUS,
      value:
        error?.response?.status === 403
          ? `${error.response.data}`
          : error?.response?.data
          ? `Error: ${error.response.data}`
          : error?.message
          ? `Error: ${error.message}`
          : `Error: ${error}`,
    });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.TOGGLE_LOADING });
    let url = `${process.env.REACT_APP_API_URL}/ad/editGroupUser`;
    let obj = {
      requestorEmail: authCtx?.user?.email,
      adGroup: state.selectedADGroup?.value,
      editUser: state.selectedGroupMember?.value?.email,
      sAMAccountName: state.selectedGroupMember?.value?.sAMAccountName,
      newUser: state.email,
    };
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    axios
      .post(url, obj, authObj)
      .then((response) => {
        submissionResponseHandler(response);
      })
      .catch((error) => {
        submissionResponseErrorHandler(error);
      });
  };

  return {
    adGroupSelectHandler,
    convertADGroupHandler,
    convertMemberHandler,
    emailChangeHandler,
    memberSelectHandler,
    submissionResponseErrorHandler,
    submissionResponseHandler,
    clearStatus,
    state,
    submitHandler,
  };
};

export default useEditUser;
